import React, { useState, useEffect } from 'react';
import { Switch, Toast } from 'antd-mobile';
import * as Request from '../../common/request';
import Page from '../../components/page';
import './index.less';

import IMG_AVATAR_DEFAULT from '../../common/images/avatar-default.png';
import IMG_ME_EXCHANGE from '../../common/images/jian1.png';
import IMG_ME_A from '../../common/images/a.png';
import IMG_ME_B from '../../common/images/b.png';
import IMG_ME_C from '../../common/images/c.png';

const PageModel = props => {
	const [userInfo, setUserInfo] = useState({});
	const getUserInfo = async () => {
		const result = await Request.get({
			url: '/user/get'
		});
		if (!result) return;
		setUserInfo(result.data);
	};

	useEffect(() => {
		getUserInfo();
	}, [123]);

	return (
		<Page {...{ page: 'user', showFooter: true, title: '我的信息' }} {...props}>
			<section className="me-container" style={{ minHeight:window.innerHeight - 50 }}>
				<div className="summary">
					<div className="user-cover" style={{ backgroundImage: `url(${userInfo && userInfo.cover || IMG_AVATAR_DEFAULT})` }} />
					<div className="userinfo">
						<div className="total"><span className="big">{userInfo.nickname}</span></div>
					</div>
				</div>
				<div className="me-entrances">
					{
						[
							{ icon: IMG_ME_A, icons: IMG_ME_EXCHANGE, label: '保养记录', link: '/upkeeplist/1' },
							{ icon: IMG_ME_B, icons: IMG_ME_EXCHANGE, label: '维修保养', link: '/upkeeplist/2' },
						].map((item, idx) => {
							return (
								<div className="item" key={idx} onClick={() => {
									if (item.link) {
										props.history.push(item.link);
									} else if (item.clickHandle && typeof item.clickHandle == 'function') {
										item.clickHandle();
									}
								}}><div className='icondiv'><img src={item.icon} /><label>{item.label}</label></div>
									<div className='items'>
										{item.msg > 0 && <div className='bagediv'>{item.msg}</div>}
										<img src={item.icons} />
									</div>
								</div>
							)
						})
					}
					<div className="item" ><div className='icondiv'><img src={IMG_ME_C} /><label>店铺状态</label></div>
							<Switch
								defaultChecked
								style={{
									'--checked-color': '#00b578',
									'--height': '36px',
									'--width': '60px',
								}}
							onChange={async val => {  //val为true时表示开关打开，false时表示关闭
									let status = val ? '1' : '0';
									let data = { "openid": userInfo.openid, "status": status }
									const result = await Request.get({
										url: '/updatecompanystatus',
										data
									});
									if (!result) return;
									Toast.show('操作成功');
									// setUserInfo(result.data);
								// setChecked(val)
							}}
							/>
					</div>
					{/* 1 普通店主 2工作人员 3 政府监管人员 4维修保养人员 5 工作人员+政府监管+维修保养 */}
				</div>
				{
					userInfo && userInfo.type == 5 &&
					<div className="exchange-worker-account" onClick={() => {
						localStorage.setItem('open', 5);
						window.location.href = '/admin';
					}}>政务监管账号</div>
				}
			</section>
		</Page>
	);
};

export default PageModel;
